export default __webpack_public_path__ + "static/media/Iniquitous Skullcap.89dd4214.jpg";